import {cn} from 'cn';
import {FLOW_VALUE_WIDTH_CLASS, flowAmountClassName, formatFlow} from '../format-money';

type FlowAmountProps = {
	value: number | null;
	asExpense: boolean;
	percent: boolean;
	emphasis: boolean;
	total: boolean;
};

export function FlowAmount({value, asExpense, percent, emphasis, total}: FlowAmountProps) {
	return (
		<span
			className={cn(
				FLOW_VALUE_WIDTH_CLASS,
				flowAmountClassName(value, asExpense),
				emphasis ? 'text-base font-bold' : total ? 'text-sm font-bold' : 'text-sm font-medium',
			)}
		>
			{formatFlow(value, asExpense, percent)}
		</span>
	);
}
